import React from 'react';
import './App.css';
import ClientIpAddress from './ClientIpAddress';

function App() {
    return (
        <div className="App">
            <ClientIpAddress />
        </div>
    );
}

export default App;